import React from "react"
import { Col, Row } from "reactstrap"
import { SystemInformation, DynamicForm } from "components/Common"
import { ModuleIds } from "constant/utility"

//i18n
import { withTranslation } from "react-i18next"

const RESOURCE = ModuleIds.Individual

const ViewMode = ({ data, t, fields }) => {
  data.createdBy = data.CreatedBy
  data.createdDate = data.CreatedDate
  data.updatedBy = data.UpdatedBy
  data.updatedDate = data.UpdatedDate
  return (
    <Row>
      <Col sm="12">
        <DynamicForm items={fields} resource={RESOURCE} isView />
      </Col>
      <Col sm="12" className="px-2">
        <SystemInformation t={t} data={data} />
      </Col>
    </Row>
  )
}

export default withTranslation(["partyPage", "common"])(ViewMode)
